// extracted by mini-css-extract-plugin
export default {"button":"Download_button__rOWgw","downloadIcon":"Download_downloadIcon__Wu3bN","downloadIconDisabled":"Download_downloadIconDisabled__ucXnp"};